import {Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import {PagerDataObject} from "../../entities/pagerDataObject";
import {CurrencyRateService} from "../../services/currency-rate.service";
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'ntr-currency-rate-list',
  templateUrl: './currency-rate-list.component.html'
})
export class CurrencyRateListComponent implements OnInit, AfterViewInit, OnDestroy {
  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.sharedService.loadMenuItems('admin');
  }

  metaInfo: string[];
  columns: Array<any>;
  data: PagerDataObject;
  subscription: any;
  private dataSub$ = new Subject<any>();

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  constructor(private currencyRateService: CurrencyRateService, private sharedService: SharedService) {
    this.subscription = this.dataSub$.pipe(switchMap(filter => {
      return this.currencyRateService.getData(filter);
    }))
      .subscribe(data => {
        this.data = data;
      });
    this.metaInfo = this.currencyRateService.getMetaInfo();
    this.columns = this.currencyRateService.getColumns();
  }

  onGridQuery(query) {
    this.dataSub$.next(query);
  }
}
